<script setup lang="ts">
import ToastContainer from '@/components/common/ToastContainer.vue'
import PageTransition from '@/components/common/PageTransition.vue'
import CookieBanner from '@/components/common/CookieBanner.vue'
import { useAnalytics } from '@/composables/useAnalytics'

useAnalytics()
</script>

<template>
  <PageTransition mode="fade" :duration="250" />
  <ToastContainer />
  <CookieBanner />
</template>

<style>
#app {
  min-height: 100vh;
}
</style>
